import { render } from "./ImgLoader.vue?vue&type=template&id=67b19fd9&scoped=true"
import script from "./ImgLoader.vue?vue&type=script&lang=js"
export * from "./ImgLoader.vue?vue&type=script&lang=js"

import "./ImgLoader.vue?vue&type=style&index=0&id=67b19fd9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Ulbi\\BlogApp\\blog_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b19fd9"]])

export default __exports__